import numberConversions from 'dibs-measurement-conversions';
import intelligentFormat from 'dibs-currency-helpers/intelligentFormat';
import { currencies } from 'dibs-currency-helpers/constants';

import { favoriteParameters, favoriteParametersMapping } from '../../constants';

/**
 * True if parameter values should be pre-processed before display
 * @return {boolean}
 */
export function shouldPreProcess(key) {
    return favoriteParametersMapping.lists.PRE_PROCESS_KEYS.indexOf(key) > -1;
}

/**
 * Returns array of pre-processed values
 * Current use case is to translate true/false bools to Yes/No
 * @return {string[]}
 */
export function preProcessValues(values) {
    return values.map(value => {
        return favoriteParametersMapping.PRE_PROCESS_DISPLAY_MAP[value] || value;
    });
}

/**
 * @return {boolean} True if key has numerical range value
 */
export function hasNumericRange(key) {
    return favoriteParametersMapping.lists.NUMERIC_RANGE_KEYS.indexOf(key) > -1;
}
/**
 * @return {boolean} True if parameter is for internal use and not display
 */
export function isInternal(key) {
    return !favoriteParametersMapping.DISPLAY_MAP[key];
}

/**
 * Format and return display value for parameter
 * @returns {string} value
 */
export function getDisplayValue(param, parameters) {
    const key = param.key;
    let values = param.values;
    let amounts = [];
    // Get currency from currency param model in params collection, default to USD
    const paramCurrency = parameters.find(
        item => item.key === favoriteParameters.keys.KEY_CURRENCY
    );
    const defaultCurrency = currencies.CURRENCY_US;
    const currency = paramCurrency ? paramCurrency.values[0] : defaultCurrency;
    let display;

    // Only pre-process if key is in map
    if (shouldPreProcess(key)) {
        values = preProcessValues(values);
    }

    if (hasNumericRange(key)) {
        // Price and currency
        if (key === favoriteParameters.keys.KEY_PRICE) {
            // Format price
            amounts = values.map(value => intelligentFormat(value, currency));
        } else {
            // Measurements
            amounts = values.map((value, index) => {
                if (value === '*') {
                    // Min / max are indicated by asterisk, replace depending on index
                    value = index > 0 ? 'Max' : 'Min';
                } else {
                    // Otherwise, must be number and convert to feet in long form
                    value = numberConversions.convert(value, 'inch', 'feet');
                    value = numberConversions.convert(value, 'feet', 'longForm');
                }
                return value;
            });
        }

        display = amounts.join(' - ');
    } else {
        // All other filters are concatenated with comma e.g. Art-Deco, Contemporary
        display = values.join(', ');
    }

    if (key === favoriteParameters.keys.KEY_STONE_CUT) {
        // Prevent from dublicating word 'Cut' as display key itself is 'Stone Cut'
        display = display.replace(' Cut', '');
    }

    return display;
}

/**
 * Lookup and return display text for key; fallback to key if not in map
 * @returns {string}
 */
export function getDisplayKey(param, parameters) {
    let key = param.key;
    const hasHeight = key === favoriteParameters.keys.KEY_HEIGHT;
    const hasCategoryL2 =
        parameters.findIndex(item => item.key === favoriteParameters.keys.KEY_CATEGORY_L2) === 0;
    const isLengthCategory =
        favoriteParametersMapping.lists.SHOW_LENGTH_CATEGORIES.indexOf(
            getDisplayValue(param, parameters)
        ) > -1;

    // TODO: Rip this logic out after BE adds numerical_length label to tell the difference b/t height and length
    if (hasHeight && hasCategoryL2 && isLengthCategory) {
        key = favoriteParameters.keys.KEY_LENGTH;
    }

    return favoriteParametersMapping.DISPLAY_MAP[key] || key;
}
